import { createFileRoute } from "@tanstack/react-router";

import { BestIndex } from "../components/best/BestIndex";
import { bestIndexHead } from "../lib/best/head";
import { loadBestCopy } from "../lib/best/index";
import { BEST_UI } from "../lib/best/ui";
import { documentHeaders } from "../lib/seo";

/** The listicle hub in English, at `/best`. */
export const Route = createFileRoute("/best/")({
  loader: () => loadBestCopy("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData ? bestIndexHead("en", BEST_UI.en, loaderData) : {},
  component: EnglishBestIndex,
});

function EnglishBestIndex() {
  const copy = Route.useLoaderData();
  return <BestIndex lang="en" ui={BEST_UI.en} copy={copy} />;
}
